var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.974609,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#4081FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4645 15.4391C13 16.9035 13 19.2606 13 23.9746C13 28.6887 13 31.0457 14.4645 32.5101C15.9289 33.9746 18.286 33.9746 23 33.9746C27.714 33.9746 30.0711 33.9746 31.5355 32.5101C33 31.0457 33 28.6887 33 23.9746C33 19.2606 33 16.9035 31.5355 15.4391C30.0711 13.9746 27.714 13.9746 23 13.9746C18.286 13.9746 15.9289 13.9746 14.4645 15.4391ZM23.75 18.9746C23.75 18.5604 23.4142 18.2246 23 18.2246C22.5858 18.2246 22.25 18.5604 22.25 18.9746V28.9746C22.25 29.3888 22.5858 29.7246 23 29.7246C23.4142 29.7246 23.75 29.3888 23.75 28.9746V18.9746ZM18.75 20.9746C18.75 20.5604 18.4142 20.2246 18 20.2246C17.5858 20.2246 17.25 20.5604 17.25 20.9746V26.9746C17.25 27.3888 17.5858 27.7246 18 27.7246C18.4142 27.7246 18.75 27.3888 18.75 26.9746V20.9746ZM28.75 21.9746C28.75 21.5604 28.4142 21.2246 28 21.2246C27.5858 21.2246 27.25 21.5604 27.25 21.9746V25.9746C27.25 26.3888 27.5858 26.7246 28 26.7246C28.4142 26.7246 28.75 26.3888 28.75 25.9746V21.9746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundwave);
export default __webpack_public_path__ + "static/media/soundwave.38b3775bb6456dfe0326c94706474a71.svg";
export { ForwardRef as ReactComponent };